import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { logout } from '../utils/auth';

export interface Stats {
  km: number;
  kg: number;
  time: number;
  kcal: number;
  exp: number;
  reps: number;
}

export interface DashboardData {
  userId: number;
  level: number;
  studio: {
    name: string;
    load: number;
    isStudioBasic: boolean;
    canUseGroupClasses: boolean;
  };
  stats: {
    today: Stats;
    week: Stats;
    month: Stats;
    all: Stats;
  };
  calendar: {
    dates: string[];
  };
}

const queryOptions = {
  queryKey: ['dashboard'],
  queryFn: async () => {
    const apiKey = localStorage.getItem('apiKey');
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_STUDIO_API_URL}/pwa/dashboard`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      return data;
    } catch (error: any) {
      if ( error.response && error.response.status === 401 && error.response.data.error === "Invalid or missing API key"
      ) { 
        logout()
      } 
      throw error;
    } 
  },
} as any;

export const useDashboard = () => {
  return useQuery<DashboardData, Error>(queryOptions);
};
